import React from 'react';
import { Path } from 'react-native-svg';

import { IconBase, IconProps } from './IconBase';

export const IconClose: React.FunctionComponent<IconProps> = ({
  strokeWidth,
  ...props
}) => (
  <IconBase {...props}>
    <Path
      d="M18 6L6 18M18 18L6 6.00001"
      stroke="currentColor"
      strokeWidth={strokeWidth || 2}
      strokeLinecap="round"
    />
  </IconBase>
);
